/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PersonRelationType {
    PIV = 'PIV',
    REPRESENTATIVE = 'REPRESENTATIVE',
    UBO = 'UBO',
    PSC = 'PSC',
    DIRECTOR = 'DIRECTOR',
    TRUSTEE = 'TRUSTEE',
    SETTLER_OR_GRANTOR = 'SETTLER_OR_GRANTOR',
    PROTECTOR_OR_ENFORCER = 'PROTECTOR_OR_ENFORCER',
    BENEFICIARY = 'BENEFICIARY',
    OTHER = 'OTHER',
}
